import { Dialog, DialogContent, Typography, DialogActions, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../css/deleteRecord.css';

export const DeleteRecord = ({ openDelete, setOpenDelete, title, handleDelete, errMsg, setErrMsg }) => {

    const { t } = useTranslation();

    const handleClose = () => {
        setOpenDelete(false);
        if (errMsg) {
            setErrMsg('');
        }
    }

    return (
        <Dialog open={openDelete} fullWidth>
            <DialogContent className='deleteRecord_dialog_content'>
                <Typography className='deleteRecord_main_text'>{title}</Typography>
                {errMsg ?
                    <Alert key={errMsg} severity="error" sx={{width: '100%'}}>{errMsg}</Alert>
                    :
                    <Alert key={errMsg} severity="warning" sx={{width: '100%'}}>{t("Attention, cette action est irréversible")}</Alert>
                }
            </DialogContent>
            <DialogActions className='deleteRecord_dialog_actions'>
                <Button className='deleteRecord_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                <Button className='deleteRecord_button_valider' variant="contained" onClick={handleDelete}>{t('Supprimer')}</Button>
            </DialogActions>
        </Dialog>
    );
};